import { styled, css } from '../../../theme';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    display: block;
    transition: transform 400ms cubic-bezier(0.25, 0, 0, 1);
  }
`;

export const VideoEl = styled.video`
  width: 100%;
  height: 100%;
  display: block;
`;

export const OtherWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings.base};
    color: #ffffff;
  `}
`;
